import * as React from "react";

function RocketIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.448 16.449L7.551 12.55C8.998 8.167 13.13 5 18 5c.323 0 .643.014.959.041.027.316.041.636.041.96 0 4.87-3.165 9-7.552 10.448z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M8 16l-1 1M9.5 17.5l-1 1M6.5 14.5l-1 1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M14 6l4 4"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14 15.5V19l-9-9h3.5"
  }));
}

export default RocketIcon;